import { schema } from "normalizr";

const workExperienceSchema = new schema.Entity("workExperiences");
const workExperienceArraySchema = new schema.Array(workExperienceSchema);

export { workExperienceSchema, workExperienceArraySchema };